__webpack_require__.p = "/simple-coffee-listing/";